// extracted by mini-css-extract-plugin
export default {"container":"FormContainer_container__BtG7t","title":"FormContainer_title__0YYZE","subtitle":"FormContainer_subtitle__cc2k6"};